import { callAPIWhiteToken } from "../config/api";

const PATH_API = process.env.REACT_APP_API;

export async function getCarouselActive() {
    const url = `${PATH_API}/carousel/active`;
    return await callAPIWhiteToken({
        url,
        method: "GET"
    });
}
